import ActionsDropdown from '@anm/components/ActionsDropdown';
import { DropdownWrapper } from '@anm/components/Dropdown';
import { flexCenter, media, Row } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { TemplateVideoWithControlsProps } from '.';
import { TemplateVideoWithControlsOrientations, VideoTypeProps } from './types';

const titleBlockWrapperAdaptiveStyles = media.desktop_small`
  margin-top: 0;    
  align-items: center;
  flex-direction: column-reverse;
`;

const TemplateVideoWithControlsWrapperAdaptiveStyles = media.desktop`
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const wrapperHorizontalStylesOnTablet = media.tablet`
  margin-bottom: 0;
`;

const wrapperChildHorizontalOnTablet = media.tablet`
  margin-top: 0;
  margin-bottom: 20px;
`;

const wrapperVerticalStylesOnDesktop = media.desktop`
  max-width: 100%;
  padding-left: 0;
  flex-direction: row;
  margin-top: 24px;
  margin-right: 0;
  align-items: flex-start;
`;

const wrapperVerticalStylesOnMobile = media.phone`
  flex-direction: column-reverse;
  align-items: center;
  h1 {
    margin-top: 20px;
  }
`;

const wrapperVerticalStylesOnGiantDesktop = media.giant`
  margin-left: auto;
  padding-left: 35px;
`;

export const TemplateVideoBottomWrapper = styled.div<{ isRow: boolean }>`
  width: 100%;
  display: flex;
  margin-top: 10px;
  pointer-events: all;
  justify-content: center;
  flex-direction: ${({ isRow }) => (isRow ? 'row' : 'column')};
  ${titleBlockWrapperAdaptiveStyles};
`;

const videoTitleOnMobile = media.phone`
  font-size: 20px;
  line-height: 32px;
  img {
    height: 24px;
  }
`;

export const VideoTitleBlock = styled.div`
  margin: 0;
  color: #fff;
  width: 100%;
  font-size: 34px;
  font-weight: bold;
  line-height: 44px;
  position: relative;
  padding-right: 45px;
  vertical-align: middle;
  ${videoTitleOnMobile};
`;

const videoDescriptionOnTablet = media.tablet`
  max-height: unset;
`;

const videoDescriptionOnMobile = media.phone`
  max-width: 100vw;
  margin-top: 20px;
  line-height: 25px;
`;

export const VideoDescription = styled.p`
  color: #fff;
  hyphens: auto;
  overflow: auto;
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 16px;
  line-height: 28px;
  max-height: 80px;
  font-weight: normal;
  ${videoDescriptionOnTablet};
  ${videoDescriptionOnMobile};
`;

const horizontal_styles = css`
  flex-direction: column;
  width: 100%;
  ${wrapperHorizontalStylesOnTablet};
  > div:last-of-type {
    margin-top: 30px;
    ${wrapperChildHorizontalOnTablet};
  }
`;

const orientations: {
  [key in TemplateVideoWithControlsOrientations]: ReturnType<typeof css>;
} = {
  vertical: css`
    flex-direction: row;
    align-items: flex-start;
    > div:last-of-type {
      justify-content: flex-start;
      margin-right: 40px;
      padding-left: 80px;
      max-width: 36%;
      ${wrapperVerticalStylesOnGiantDesktop};
      ${wrapperVerticalStylesOnDesktop};
      ${wrapperVerticalStylesOnMobile};
    }
  `,
  horizontal: css`
    ${horizontal_styles};
  `,
  horizontal_with_slider: css`
    ${horizontal_styles};
  `
};

const TemplateVideoWithControlsWrapper = styled.div<TemplateVideoWithControlsProps>`
  ${flexCenter};
  margin-bottom: 50px;
  pointer-events: none;
  ${TemplateVideoWithControlsWrapperAdaptiveStyles};

  ${({ orientation }) => [...orientations[orientation]]};
`;

export const paddingTop = css`
  padding-top: 56px;
`;

export const horizontalPadding = css`
  padding: 0 56px;
`;

const templateVideoPlayerHorizontalOnMobile = media.phone<VideoTypeProps>`
 ${({ isVideoVertical }) => (isVideoVertical ? horizontalPadding : paddingTop)}
`;

export const TemplateVideoPlayerHorizontalWrapper = styled.div<VideoTypeProps>`
  width: 100%;
  pointer-events: none;
  ${templateVideoPlayerHorizontalOnMobile};
`;

const columnOnTablet = media.tablet`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const EditButtonWrapper = styled.div<{ isSingleButton?: boolean }>`
  ${({ isSingleButton }) =>
    isSingleButton &&
    css`
      margin-right: 30px;
    `}
`;

const titleRowStylesTablet = media.tablet`
  ${VideoTitleBlock} {
    padding: 0 20px;
  };
  ${EditButtonWrapper} { margin: 0 auto 30px; }
`;

export const TitleRow = styled(Row)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row-reverse;
  a {
    margin-left: auto;
  }
  ${titleRowStylesTablet};
  ${columnOnTablet};
`;

const descriptionRowOnTablet = media.tablet`
  ${VideoDescription} {
    padding: 0 20px;
  }
`;

export const DescriptionRow = styled(Row)`
  align-items: flex-start;
  justify-content: flex-start;
  ${columnOnTablet};
  ${descriptionRowOnTablet};
`;

export const PremiumIconWrapper = styled.div`
  ${flexCenter};
  display: inline;
  min-height: 44px;
  img {
    margin-top: -3px;
    margin-left: 18px;
    vertical-align: middle;
  }
`;

export const ActionsDropdownWrapper = styled(ActionsDropdown)`
  ${DropdownWrapper} {
    right: 0;
    top: 30px;
    position: absolute;
  }
`;

export default TemplateVideoWithControlsWrapper;
